<ng-template #drawerContent let-offcanvas>
  <div class="offcanvas-container">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title">{{ title }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
    </div>
    <div class="offcanvas-body">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
